export const IMAGE_WIDTH = 350;
export const IMAGE_HEIGHT = 350;
export const DEFAULT_404_PHOTO = '//is.alibaba.com/images/eng/no_photo_w250h250.gif';